import { Button } from '@buildmate/ui-web';
import { usePorts } from '../lib/ports-context.tsx';

/**
 * An account exists but belongs to no active company — the state between
 * accepting an invite that was later revoked, or a half-finished sign-up.
 */
export function NoCompany() {
  const ports = usePorts();
  return (
    <main className="grid min-h-full place-items-center p-6 text-center">
      <div className="max-w-sm">
        <h1 className="text-lg font-semibold text-slate-900">No active company</h1>
        <p className="mt-1 text-sm text-slate-600">
          This account is not an active member of any company. Ask an administrator to invite you,
          or sign out and create a company of your own.
        </p>
        <Button variant="secondary" className="mt-4" onClick={() => void ports.auth.signOut()}>
          Sign out
        </Button>
      </div>
    </main>
  );
}
